module.exports = __webpack_public_path__ + "static/media/img18.4ee69c90.jpg";